import api from "../api/client";

const freightApi2 = {
  create(payload, releaseFreight = false) {
    return api.post(
      `/freight/save?isReleaseFreight=${releaseFreight}`,
      payload,
    );
  },

  update(id, payload, isFinalize = false, releaseFreight = false) {
    return api.patch(
      `/freight/update/${id}?isFinalize=${isFinalize}&isReleaseFreight=${releaseFreight}`,
      payload,
    );
  },

  cancel(id, payload, reason) {
    return api.patch(`/freight/v1/cancel/${id}`, {
      ...payload,
      reason,
    });
  },

  getById(id) {
    return api.get(`/freight/getFreightByIdWithStoppingPoints/${id}`);
  },

  getAllFreights(params) {
    return api.get("/freight", { params });
  },

  /*Lista paginada (cursor) com filtros no servidor — GET /freight/v2 */
  getAllFreightsV2(params) {
    return api.get("/freight/v2", { params });
  },

  delete(id) {
    return api.delete(`/freight/delete/${id}`);
  },

  queue(id) {
    return api.get(`/freight/${id}/queue`);
  },

  transportQueue(id, isShipper) {
    return api.get(`/freight/${id}/transport-queue`, {
      params: { isShipper },
    });
  },

  getAvailableFreights(params) {
    return api.get("/freight/available", { params });
  },

  getAvailableFreightById(id, idCarrier) {
    return api.get(`/freight/available/${id}`, {
      params: idCarrier ? { idCarrier } : undefined,
    });
  },

  enterTransportQueue(id, payload = {}) {
    return api.post(`/freight/available/${id}/enter-queue`, payload);
  },

  leaveTransportQueue(id, payload = {}) {
    return api.post(`/freight/available/${id}/leave-queue`, payload);
  },

  getCarrierApplications(params = {}) {
    return api.get("/freight/carrier-applications", { params });
  },

  acceptTransportQueue(id, payload = {}) {
    return api.post(`/freight/${id}/transport-queue/accept`, payload);
  },
};

export default freightApi2;
